module.exports = __webpack_public_path__ + "img/bnr_quest.3f4888dd.png";